import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-desc-icon',
  templateUrl: 'desc-icon.component.html'
})
export class DescIconComponent {
  constructor() {}
}
